import React, { useState } from 'react'
import { Box, Container, Grid, Typography, IconButton } from '@mui/material'
import { styled } from '@mui/material/styles'
import ChevronLeftIcon from '@mui/icons-material/ChevronLeft'
import ChevronRightIcon from '@mui/icons-material/ChevronRight'
import wave1 from '../assets/images/AZ8_7174.jpg'
import wave2 from '../assets/images/AZ8_6420.jpg'
import wave3 from '../assets/images/AZ8_6268.jpg'
import smt1 from '../assets/images/smt11.jpg'
import smt2 from '../assets/images/smt2.jpg'
import smt3 from '../assets/images/smt3.jpg'
import smt4 from '../assets/images/smt4.jpg'
import smt5 from '../assets/images/smt5.jpg'
import smt6 from '../assets/images/smt6.jpg'
import smt7 from '../assets/images/smt7.jpg'
import smt8 from '../assets/images/smt8.jpg'
import smt9 from '../assets/images/smt9.jpg'
import prod3 from '../assets/images/prod3.jpg'
const StyledSubtitle = styled(Typography)(({ theme }) => ({
  color: '#000',
  marginBottom: theme.spacing(3),
  transition: 'opacity 0.3s ease-in-out',
}))

const TextContainer = styled(Box)({
  position: 'relative',
  minHeight: '300px',
})

const ContentWrapper = styled(Box)({
  position: 'absolute',
  width: '100%',
  transition: 'opacity 0.3s ease-in-out',
  opacity: 0,
  '&.active': {
    opacity: 1,
  }
})

const ContentText = styled(Typography)(({ theme }) => ({
  marginBottom: theme.spacing(3),
  lineHeight: 1.6,
  display: 'block',
  width: '100%',
}))


const CarouselContainer = styled(Box)(({ theme }) => ({
  position: 'relative',
  width: '100%',
  height: '100%',
  minHeight: 500,
  overflow: 'hidden',
  [theme.breakpoints.down('md')]: {
    minHeight: 300,
  },
}))

const CarouselImage = styled('img')({
  width: '100%',
  height: '100%',
  objectFit: 'cover',
  position: 'absolute',
  top: 0,
  left: 0,
  transition: 'opacity 0.3s ease-in-out',
  opacity: 0,
  '&.active': {
    opacity: 1,
  },
})

const CarouselButton = styled(IconButton)(({ theme }) => ({
  position: 'absolute',
  top: '50%',
  transform: 'translateY(-50%)',
  backgroundColor: 'rgb(255, 255, 255)',
  '&:hover': {
    backgroundColor: 'rgba(255, 255, 255, 0.9)',
  },
}))

const CarouselDots = styled(Box)(({ theme }) => ({
  position: 'absolute',
  bottom: theme.spacing(2),
  left: '50%',
  transform: 'translateX(-50%)',
  display: 'flex',
  gap: theme.spacing(1),
}))

const CarouselDot = styled(Box)(({ theme }) => ({
  width: 8,
  height: 8,
  borderRadius: '50%',
  backgroundColor: 'rgba(255, 254, 251, 0.5)',
  cursor: 'pointer',
  transition: 'background-color 0.3s ease-in-out',
  '&.active': {
    backgroundColor: 'rgba(244, 152, 13, 0.93)',
  },
}))
export default function SmtManufacturing() {
  const [activeSlide, setActiveSlide] = useState(0)

  const slides = [
    {
      image: smt1,
      title: "Our SMT Manufacturing Capabilities",
      description1: "At Bhagwati Products Limited, we excel in advanced Surface Mount Technology (SMT) manufacturing, setting new benchmarks in quality and precision for electronics production.",
      description2: "With state-of-the-art facilities and unmatched expertise, we deliver innovative, reliable, and efficient solutions that meet the dynamic demands of modern industries."
    },
    {
      image: smt2,
      title: "SMT - MES Integration",
      description1: "We seamlessly integrate advanced Surface Mount Technology (SMT) with Manufacturing Execution Systems (MES) to deliver real-time insights and maximize production efficiency.",
      description2: "This powerful SMT-MES integration empowers businesses to monitor operations, uphold exceptional quality standards, and make data-driven decisions that drive superior performance and productivity."
    },
    {
      image: smt3,
      title: "PCBA Test & Inspection Control",
      description1: "We provide end-to-end PCBA Test & Inspection Control services to ensure unmatched quality and performance. Using advanced methods like In- Circuit Testing (ICT), Functional Testing, X-Ray Inspection (AXI), and Automated Optical Inspection (AOI), we identify defects early, ensuring every PCBA meets the highest operational standards.",
      description2: " Our rigorous quality assurance processes empower clients across industries-electronics, automotive, and medical devices-to deliver reliable, defect-free products with confidence."
    },
    {
      image: smt4,
      title: "PCB Calibration Lines",
      description1: "We specialize in high-precision PCB Calibration Lines, designed to ensure every printed circuit board meets the highest accuracy standards. Our advanced systems minimize defects and maximize performance, delivering consistent results for both high-speed manufacturing and sensitive electronic applications.",
      description2: "Essential for enhancing product quality and reliability, our calibration lines are a crucial part of your production process."
    },
    {
      image: smt5,
      title: "Final Assembly Lines",
      description1: "Our Final Assembly Lines are engineered to streamline production processes, ensuring the seamless integration of all components. With a focus on efficiency and precision, our assembly lines deliver flawless final products ready for market.",
      description2: "We prioritize timely delivery without compromising on quality, making sure that every product is meticulously assembled and meets the highest standards. Whether you're dealing with complex electronics or large-scale manufacturing, our final assembly lines ensure your products are ready to meet customer demands with reliability."
    },
    {
      image: smt6,
      title: "Production Lines – TWS & SWC",
      description1: "At Bhagwati Products Limited, our Production Lines for True Wireless Stereo (TWS) and Smart Wearable Components (SWC) are at the forefront of innovation. Designed for precision and high-volume manufacturing, these specialized production lines cater to the unique needs of TWS and wearable technology.",
      description2: "We combine cutting-edge automation with expert craftsmanship to ensure that every component is manufactured to the highest standards of quality and performance. From seamless integration to rigorous testing, our production lines help bring the latest in audio and wearable technology to life, efficiently and reliably."
    },
    {
      image: smt7,
      title: "Testing Equipment - TWS",
      description1: "Our Testing Equipment for TWS (True Wireless Speakers) is designed to elevate audio quality by ensuring precision performance in every device. Utilizing state-of-the-art technology, our testing systems thoroughly evaluate sound clarity, connectivity, and battery life, guaranteeing that each product meets the highest industry standards.",
      description2: " With comprehensive testing protocols, we ensure that every True Wireless Speaker delivers exceptional sound quality and reliability, enhancing the user experience and driving innovation in the audio technology market."
    },
    {
      image: smt8,
      title: "Testing Equipment - Smart Watch",
      description1: "Our Testing Equipment for Smart Watches is engineered to empower innovation by ensuring peak performance and reliability in every device. Utilizing advanced testing technologies, we thoroughly evaluate key functions such as battery life, connectivity, sensors, and display quality, ensuring each Smart Watch meets rigorous industry standards.",
      description2: " With precise testing protocols, we guarantee that every Smart Watch performs seamlessly, providing users with a reliable, high-performance wearable that supports their dynamic lifestyle."
    },
    {
      image: prod3,
      title: "Setup Capability – TWS/SWC",
      description1: "Our Setup Capability for TWS/SWC offers comprehensive testing with 24 dedicated stations designed to ensure excellence in every aspect of performance. This includes rigorous assessments of Bluetooth and Wi-Fi connectivity, acoustic quality, and waterproofing standards.",
      description2: "By leveraging advanced technologies and a highly efficient testing process, we guarantee that True Wireless Stereo (TWS) devices and Smart Watches meet the highest industry benchmarks, delivering exceptional quality and reliability to users."
    },
    {
      image: smt9,
      title: "FA Shop-Floor View",
      description1: "Our FA Shop-Floor View provides a real-time, transparent look at the heart of our production process. It showcases seamless integration of advanced technology and human expertise, ensuring optimal efficiency at every stage.",
      description2: "From assembly to quality control, this dynamic view allows you to witness firsthand how innovation drives precision, consistency, and timely delivery across our entire manufacturing floor."
    }
  ]

  const handlePrevious = () => {
    setActiveSlide((prev) => (prev === 0 ? slides.length - 1 : prev - 1))
  }

  const handleNext = () => {
    setActiveSlide((prev) => (prev === slides.length - 1 ? 0 : prev + 1))
  }

  return (
    <Container maxWidth="xl" sx={{ py: 4 }}>
      <br/>
      <Grid container spacing={4}>
        <Grid item xs={12} md={5}>
          <TextContainer>
            {slides.map((slide, index) => (
              <ContentWrapper
                key={index}
                className={index === activeSlide ? 'active' : ''}
                sx={{ opacity: index === activeSlide ? 1 : 0 }}
              >
                <StyledSubtitle 
                  variant="h3" 
                  component="h2"
                  sx={{ opacity: index === activeSlide ? 1 : 0 }}
                >
                  {slide.title}
                </StyledSubtitle>
                <ContentText variant="body1">
                  {slide.description1}
                </ContentText>
                <ContentText variant="body1">
                  {slide.description2}
                </ContentText>
              </ContentWrapper>
            ))}
          </TextContainer>
        </Grid>
        <Grid item xs={12} md={7}>
          <CarouselContainer>
            {slides.map((slide, index) => (
              <CarouselImage
                key={index}
                src={slide.image}
                alt={`Slide ${index + 1}`}
                className={index === activeSlide ? 'active' : ''}
              />
            ))}
            <CarouselButton
              onClick={handlePrevious}
              sx={{ left: 16 }}
              aria-label="Previous slide"
            >
              <ChevronLeftIcon />
            </CarouselButton>
            <CarouselButton
              onClick={handleNext}
              sx={{ right: 16 }}
              aria-label="Next slide"
            >
              <ChevronRightIcon />
            </CarouselButton>
            <CarouselDots>
              {slides.map((_, index) => (
                <CarouselDot
                  key={index}
                  className={index === activeSlide ? 'active' : ''}
                  onClick={() => setActiveSlide(index)}
                />
              ))}
            </CarouselDots>
          </CarouselContainer>
        </Grid>
      </Grid>
    </Container>
  )
}